import LineView from '../../Chart/Views/LineView';
import React from 'react';
import { Flex, Spinner } from '@patternfly/react-core';
import { useTranslation } from '../../../localization/useTranslation';
import './ChartPanel.scss';
import T from '../../../localization/LocalizationKeys';
import Icons, { Size } from '../../Common/Icons';
import ModelType from '../../Model/ModelType';
import _ from 'lodash';
import useInterval from '../../../utils/hooks/useInterval';

const DEFAULT_REFRESH_INTERVAL = 5; // 5 minutes
const MIN_REFRESH_INTERVAL = 1; // 5 minutes

const ChartPanelContent = ({
  isLoading = false,
  hasError = false,
  timespan,
  data = [],
  plotlines,
  isLoadingPlotlines = false,
  // signalData,
  reload,
  refreshInterval,
  reflowTrigger
}) => {

  useInterval(reload, Math.max(MIN_REFRESH_INTERVAL, (refreshInterval ?? DEFAULT_REFRESH_INTERVAL) * 60000));

  const T = useTranslation();
  const loadingDescription = hasError ? T.common.error.generic : T.common.loading;
  return (
    <div className={'chart-panel-container'}>
      { (isLoading || isLoadingPlotlines || hasError) && <Flex alignItems={{ default: 'alignItemsCenter' }}>
        <Spinner size="md" />
        <span>{ loadingDescription }</span>
      </Flex> }
      <LineView
        graphDataPackage={data}
        timespan={timespan}
        reflowTrigger={reflowTrigger}
        plotlines={plotlines}
      />
    </div>
  );
};

const ChartPanel = ({ data, api }) => {
  const plotlines = data.plotlineValues?.plotlines ?? [];
  return (<ChartPanelContent {...data.signalValues}
    plotlines={plotlines} reload={api.reload}
    reflowTrigger={api.size.width} refreshInterval={data.refreshInterval}/>);
};

ChartPanel.info = {
  label: T.dashboard.panels.types.chart,
  icon: <Icons.ChartLine size={Size.LARGE}/>,
  help: 'panels/chart'
};

ChartPanel.properties = {
  signalValues: {
    type: 'signals'
  },
  plotlineValues: {
    type: 'plotlines'
  }
};

ChartPanel.models = [
  {
    path: 'refreshInterval',
    type: ModelType.NUMBER,
    label: T.common.refreshInterval,
    placeholder: _.toString(DEFAULT_REFRESH_INTERVAL)
  }

];

export default React.memo(ChartPanel);
